import { Button, Card, Col, message, Row } from "antd";
import React from "react";
import { useState } from "react";
import BulkModal from "./BulkModal";
import { useDispatch } from "react-redux";
import { submitForm } from "../../redux/actions/basicFormAction";
import { useSelector } from "react-redux";
import { postRequest } from "../../services/mainApp.service";
import Title from "antd/lib/typography/Title";
import { IoMdCloudUpload } from "react-icons/io";

const BulkUpload = () => {
  const [bulkInventoryModal, setBulkInventoryModal] = useState(false);
  const [bulkVendorModal, setBulkVendorModal] = useState(false);
  const [bulkPosRecipeModal, setBulkPosRecipeModal] = useState(false);
  const [bulkSubRecipeModal, setBulkSubRecipeModal] = useState(false);

  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);
  const [loading, setLoading] = useState(false);
  const [uploadType, setUploadType] = useState(null);
  const [uploadComments, setUploadComments] = useState("");



  //handle bulk upload retail(inventory) products function
  const handleInventoryFormSubmit = (event, file) => {
    event.preventDefault();
    if (!file) {
      message.error("Please select a file");
      return;
    }
    if (!userData?.CompanyId || !userData?.UserId) {
      message.error("User session data is missing. Please log in again.");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("CompanyId", userData.CompanyId);
    formData.append("OperationId", 2);
    formData.append("UserId", userData.UserId);
    formData.append("UploadType", uploadType);
    formData.append("UserIP", userData.UserIP);

    postRequest("Inv_BulkUpload", formData).then((res) => {

      if (res.error === true) {
        setLoading(false);
        message.error(res.errorMessage);

        if (res.data.DataSet.Table1 && res.data.DataSet.Table1.length > 0) {
          const comments = res.data.DataSet.Table1.map((item) =>
            item?.Comments || item?.Comment || JSON.stringify(item)
          ).join("\n");
          setUploadComments(comments);
        }

        return;
      }
      if (res.data.response === false) {
        setLoading(false);
        message.error(res.DataSet.Table.errorMessage);
        return;
      }

      message.success("Bulk data uploaded successfully!");
      setUploadComments("");
      setLoading(false);
      setBulkInventoryModal(false);
      setBulkVendorModal(false);
    });
  };


  return (
    <>
      <div style={{ margin: 5 }}>
        <Title level={3} >
          Bulk Uploads
        </Title>
        <div
          style={{
            background: "white",
            padding: 15,
            boxShadow: "0 0 5px lightgray",
            borderRadius: 2,
          }}
        >
          <Row gutter={[8, 8]} style={{ width: "100%", padding: 10 }}>
            <Col span={3}>
              <Button
                type="primary"
                onClick={() => {
                  setBulkInventoryModal(true);
                  setUploadType("InventoryItem");
                  setUploadComments("");
                }}
                style={{ width: "100%" }}>
                Inventory Items
              </Button>
            </Col>

            <Col span={3}>
              <Button
                type="primary"
                onClick={() => {
                  setBulkVendorModal(true);
                  setUploadType("Vendor");
                  setUploadComments("");
                }}
                style={{ width: "100%" }}>
                Vendors
              </Button>
            </Col>

            <Col span={3}>
              <Button
                type="primary"
                onClick={() => {
                  setBulkPosRecipeModal(true);
                  setUploadType("PosRecipe");
                  setUploadComments("");
                }}
                style={{ width: "100%" }}>
                POS Recipes
              </Button>
            </Col>

            <Col span={3}>
              <Button
                type="primary"
                onClick={() => {
                  setBulkSubRecipeModal(true);
                  setUploadType("SubRecipe");
                  setUploadComments("");
                }}
                style={{ width: "100%" }}>
                Sub Recipes
              </Button>
            </Col>
          </Row>
        </div>

        <BulkModal
          title="Inventory Items"
          isModalVisible={bulkInventoryModal}
          handleCancel={() => setBulkInventoryModal(false)}
          width={"40vw"}
          handleOk={handleInventoryFormSubmit}
          isLoading={loading}
          sampleFileURL="/BulkFiles/ItemUpload.xlsx"
          comments={uploadComments}
        />

        <BulkModal
          title="Vendors"
          isModalVisible={bulkVendorModal}
          handleCancel={() => setBulkVendorModal(false)}
          width={"40vw"}
          handleOk={handleInventoryFormSubmit}
          isLoading={loading}
          sampleFileURL="/BulkFiles/VendorUpload.xlsx"
          comments={uploadComments}
        />

        <BulkModal
          title="Pos Recipes"
          isModalVisible={bulkPosRecipeModal}
          handleCancel={() => setBulkPosRecipeModal(false)}
          width={"40vw"}
          handleOk={handleInventoryFormSubmit}
          isLoading={loading}
          sampleFileURL="/BulkFiles/ProductRecipeUpload.xlsx"
          comments={uploadComments}
        />

        <BulkModal
          title="Sub Recipes"
          isModalVisible={bulkSubRecipeModal}
          handleCancel={() => setBulkSubRecipeModal(false)}
          width={"40vw"}
          handleOk={handleInventoryFormSubmit}
          isLoading={loading}
          sampleFileURL="/BulkFiles/SubRecipeUpload.xlsx"
          comments={uploadComments}
        />
      </div>
    </>
  );
};

export default BulkUpload;
